import "./MapPins.css";
import React, { useState } from "react";

const MapPins = ({ data, closePopup, handleClick, isMobile }) => {
  const [clickedId, setClickedId] = useState(-1);
  const [animationClass, setAnimationClass] = useState("invisible");
  const [animationTimer, setAnimationTimer] = useState();
  const [animatedData, setAnimatedData] = useState();

  var pixelData;
  function highlightGroup(event, id) {
    var img = event.target;
    var canvas = document.createElement("canvas");
    canvas.width = img.width;
    canvas.height = img.height;
    canvas.getContext("2d").drawImage(img, 0, 0, img.width, img.height);

    pixelData = canvas.getContext("2d").getImageData(event.nativeEvent.offsetX, event.nativeEvent.offsetY, 1, 1).data;

    for (var i = 0; i < pixelData.length; i++) {
      if (pixelData[i] !== 0) {
        setClickedId(id);
      } else {
        setClickedId(-1);
      }
    }
  }
  return (
    <div className="MapPinsContainer">
      {data !== null
        ? data.pins.map((pin, i) => {
            if (data !== animatedData) {
              setAnimationClass("invisible");
              setTimeout(() => {
                setAnimationClass("animate");
              }, 10);
              setAnimatedData(data);
            }

            return (
              <div
                key={i}
                className="App-map-icon"
                onClick={closePopup}
                style={{ display: "flex", justifyContent: "center", left: pin.xPosition, top: pin.yPosition, width: pin.size }}
              >
                <img
                  id={pin.title}
                  alt="Normal Map Icon"
                  className={`Map-Pin ${animationClass}`}
                  onMouseMove={(event) => {
                    highlightGroup(event, i);
                  }}
                  onClick={(event) => {
                    handleClick(event, pin);
                    event.stopPropagation();
                  }}
                  src={require(`./content/pins/pin-${data.colour}.png`).default}
                  style={{
                    position: "absolute",
                    bottom: "50%",
                    width: `${isMobile + 1 + (clickedId === i)}vw`,
                    cursor: clickedId === i ? "pointer" : "default",
                  }}
                />
              </div>
            );
          })
        : null}
    </div>
  );
};

export default MapPins;
